import { createSlice } from '@reduxjs/toolkit';
import { BatchState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getSampleBatchThunk } from './thunks';

// Initial State
const initialState: BatchState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const batchSlice = createSlice({
  name: 'batch',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getSampleBatchThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getSampleBatchThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getSampleBatchThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = batchSlice.actions;
export * from './thunks';
export * from './selectors';
export default batchSlice.reducer;
